; (function (jQuery) {
    "use strict";

    function MemberEvents() {
        var fn = {
            init: function () {
                jQuery('.js-member-event-btn').on('click', fn.handleShowEventMonth);
            },

            handleShowEventMonth: function(e) {
                jQuery('.js-member-event-btn').removeClass('member-events__month-btn--active');
                const $monthBtn = jQuery(e.target);
                $monthBtn.addClass('member-events__month-btn--active');
                const month = $monthBtn.attr('data-button-month');
                const monthDetails = jQuery('[data-details-month=' + month + ']');
                jQuery('.js-member-events-month').hide();
                monthDetails.show();
            },
        }

        jQuery(fn.init);
    }

    new MemberEvents();
})(jQuery);